import styled from 'styled-components';

const UserImg = styled.div`
  background-color: #bab8b8;
  width: 30px;
  height: 30px;
  border-radius: 15px;
`;

export { UserImg };
